@if (open()) {
  <app-inline-dialog class="!w-[440px] rounded-2xl">
    <mat-tab-group (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedTab()">
      <mat-tab>
        <ng-template mat-tab-label>
          <p>Activity</p>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <div class="flex items-center">
            <p>Review queue</p>
            @if (reviewTotal()) {
              <div class="p-0 rounded-full bg-gray flex items-center justify-center text-white h-5 w-8 text-xs">
                {{ reviewTotal() }}
              </div>
            }
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
    <div class="flex flex-col mt-5 scrollable relative">
      @if (selectedTab() === NotificationEnum.REVIEW && !!notifications().length) {
        <div class="flex justify-end items-center absolute right-0 top-1 z-[2]">
          @if (isEdit()) {
            <button class="edit-button reject" (click)="rejectAll()">Reject</button>
            <button class="edit-button approve" (click)="approveAll()">Approve</button>
          } @else {
            <button class="edit-button select" (click)="toggleEdit()">Select</button>
          }
        </div>
      }
      @for (date of notifications(); track $index) {
        <div class="day">
          <p [class]="'mb-[14px] text-gray text-md ' + (date[0] === DayEnum.TODAY ? 'font-bold' : 'font-semibold')">
            {{ date[0] }}
          </p>
        </div>
        <div class="flex flex-col">
          @for (notification of date[1]; track $index) {
            <div class="flex items-start w-full">
              <mat-checkbox
                class="text-blue checkbox"
                [class.hide]="!isEdit()"
                [checked]="selectedIds().includes(notification.id)"
                (change)="toggleId(notification.id)"
              >
              </mat-checkbox>
              <a
                [class]="'notification flex items-start mb-5 cursor-pointer notification-info'"
                [class.has-checkbox]="isEdit()"
                [routerLink]="getNotificationLink(notification)"
                (click)="notificationClicked(notification)"
              >
                @if (notification.image) {
                  <img
                    [src]="notification.image"
                    alt=""
                    [class]="
                      'size-10 shrink-0 object-cover rounded-[7px] mr-4 ' +
                      (notification.notificationType === 'followerRequest' ? '' : 'rounded-[7px]')
                    "
                  />
                } @else {
                  <app-icon
                    [name]="notification.notificationType === 'followerRequest' ? 'heroUserCircle' : 'heroPhoto'"
                    [class]="'size-10 notification-icon mr-4'"
                  ></app-icon>
                }
                <div
                  class="flex flex-col pt-1 notification-content"
                  [class.has-activity-button]="hasActivityButton(notification)"
                >
                  <p class="text-xs notification-title font-bold leading-[18px] flex items-center">
                    <span class="block truncate mr-1">{{ notification.title }}</span>
                    @if (!!notification.titleSuffix) {
                      <span
                        [class]="
                          'font-normal whitespace-nowrap' +
                          (['commentForApprove', 'commentNew'].includes(notification.notificationType)
                            ? ' text-gray'
                            : '')
                        "
                        >{{ notification.titleSuffix }}</span
                      >
                    }
                  </p>
                  <p
                    [class]="
                      'text-xs leading-[18px] ' +
                      (notification.viewed || preRead().includes(notification.id) ? 'text-gray' : 'text-blue')
                    "
                  >
                    {{ notification.description }}
                  </p>
                  @if (selectedTab() === NotificationEnum.REVIEW && !notification.metadata.handled) {
                    <div class="flex items-center mt-4">
                      <button
                        appButton
                        color="outlineBlue"
                        class="!py-1 !px-7 !rounded-[7px] text-xs leading-[18px]"
                        (click)="approve(notification.metadata.commentId || '', notification.id, $event)"
                      >
                        Approve
                      </button>
                      <button
                        appButton
                        color="white"
                        class="bg-none !py-1 !px-7 text-yellow text-xs leading-[18px]"
                        (click)="reject(notification.metadata.commentId || '', notification.id, $event)"
                      >
                        <app-icon name="warning" size="small" class="size-4 button-icon mr-2"></app-icon>
                        Reject
                      </button>
                    </div>
                  }
                </div>

                @if (hasActivityButton(notification)) {
                  <div class="flex items-center mt-1.5 ml-auto w-[160px]">
                    <button
                      appButton
                      color="outlineBlue"
                      class="!py-1 !px-7 !rounded-[7px] text-xs leading-[18px] whitespace-nowrap"
                      (click)="share(notification.metadata.userId, notification.id, $event)"
                    >
                      Share to
                    </button>
                    <button
                      appButton
                      color="white"
                      class="bg-none !py-1 !px-1 text-yellow text-xs leading-[18px]"
                      (click)="delete(notification.metadata.userId, notification.id, $event)"
                    >
                      <app-icon name="delete" size="small" class="size-4 button-icon mr-2"></app-icon>
                    </button>
                  </div>
                }
              </a>
            </div>
          }
        </div>
      } @empty {
        <p class="notification-title text-lg font-bold">List is empty</p>
        <p class="notification-title text-xs">You don't have notifications yet</p>
      }
      <div #loadMore class="h-10"></div>
    </div>
  </app-inline-dialog>
}
